import type { ButtonHTMLAttributes, ReactNode } from 'react';

import { cn } from '@/utils/cn';

type MenuToggleButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  isOpen: boolean;
  label?: ReactNode;
  compact?: boolean;
};

export function MenuToggleButton({
  isOpen,
  label,
  compact = false,
  className,
  ...props
}: MenuToggleButtonProps) {
  return (
    <button
      type="button"
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      aria-expanded={isOpen}
      className={cn(
        'tap-target inline-flex items-center justify-center gap-2 rounded-[1rem] transition duration-200 ease-out',
        compact ? 'h-10 w-10' : 'flex-col px-1 py-1',
        className
      )}
      {...props}
    >
      <span className="relative block h-4 w-5 shrink-0">
        <span
          aria-hidden="true"
          className={cn(
            'absolute left-0 top-0.5 h-0.5 w-5 rounded-full bg-current transition duration-200 ease-out',
            isOpen ? 'translate-y-[5px] rotate-45' : ''
          )}
        />
        <span
          aria-hidden="true"
          className={cn(
            'absolute left-0 top-[7px] h-0.5 w-5 rounded-full bg-current transition duration-200 ease-out',
            isOpen ? 'scale-x-0 opacity-0' : ''
          )}
        />
        <span
          aria-hidden="true"
          className={cn(
            'absolute left-0 top-[13px] h-0.5 w-5 rounded-full bg-current transition duration-200 ease-out',
            isOpen ? '-translate-y-[7px] -rotate-45' : ''
          )}
        />
      </span>
      {label ? <span className="whitespace-nowrap">{label}</span> : null}
    </button>
  );
}
